import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/live-reservation-selection-action-types';

import type {List} from 'immutable';

export type LiveReservationSelectionStore = {
    reservations: List<unknown>;
};

const initialState = (): LiveReservationSelectionStore => {
    return {
        reservations: Immutable.List(),
    };
};

const actionsMap = {
    [actionTypes.LIVE_RESERVATION_SELECTION_GET_RESERVATIONS_SUCCESS]: (state, action) => {
        return {
            reservations: action.data,
        };
    },
    [actionTypes.LIVE_RESERVATION_SELECTION_DISPOSE_STORE]: () => {
        return initialState();
    },
};

export default createReducer<LiveReservationSelectionStore>(initialState(), actionsMap);
